import React from 'react';
import { Divider, Typography } from '@mui/material';
import kola from '../../../../../images/Agri-info/crops/banana_কলা.jpg';
import useDocumentTitle from '../../../../../hooks/useDocumentTitle';

const KolaInfo = () => {

    // dynamic title
    useDocumentTitle("কলা");

    return (

        <div className=" rounded-3 bg-white my-4 px-5">
            <Typography
                sx={{
                    textAlign: "center",
                    pb: 2,
                    pt: 3,
                    fontWeight: 600,
                    color: 'rgb(37, 36, 36, 0.83)'
                }}
                variant="h3"
                noWrap
                component="div"
            >
                কলা
            </Typography>
            <Divider />

            <div className="card mt-4 mb-3 border-0 rounded-0">
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src={kola} className="img-fluid rounded-0 h-100" alt="..." />
                    </div>
                    <div className="col-md-8">
                        <div className="card-body text-start ">
                            <p className="card-text"><b>পুষ্টি মূল্য : </b>ক্যালসিয়াম, লৌহ ও ভিটামিন সি রয়েছে।</p>
                            <p className="card-text"><b>ভেষজ গুণ: </b><br />পাকা কলা কোষ্ঠকাঠিন্য দূর করে এবং কলার থোড় বা মোচা ডায়াবেটিস, আমাশয়, আলসার নিরাময়ে ব্যবহৃত হয়।</p>
                            <p className="card-text"><b>উপযুক্ত জমি ও মাটি: </b><br />উর্বর দোআঁশ মাটি ও পানি জমে না এমন উঁচু জমি কলা চাষের জন্য ভাল।</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='text-start pb-5'>
                <p className="card-text"><b>জাত পরিচিতি: </b><br />অমৃত সাগর, চাম্পা, চিনি চাম্পা, সবরি, বারি কলা-১, বারি কলা-৪।</p>
                <p className="card-text"><b>চারা রোপণ: </b><br />জমি ভালভাবে গভীর করে চাষ দিতে হয়। দুই মিটার দূরে দূরে ২ ফুট গভীর করে গর্ত তৈরি করে নিতে হয়। কলার চার বছরে তিন মৌসুমে রোপণ করা যায়-আশ্বিন-কার্তিক, মাঘ-ফাল্গুন এবং চৈত্র-বৈশাখ। রোপণের জন্য অসি তেউড় (ঝড়িৎফ ঝঁপশবৎ) সবচেয়ে ভাল।</p>
                <p className="card-text"><b>সার ব্যবস্থাপনা: </b><br />প্রতি গর্তে গোবর ২০ কেজি, টিএসপি সার ৪০০ গ্রাম, ৩০০ গ্রাম এমওপি সার এবং ইউরিয়া সার ৬৫০ গ্রাম প্রয়োগ করতে হয়। সারের ৫০ ভাগ গোবর জমি তৈরির সময় এবং বাকি ৫০ভাগ গর্তে দিতে হয়। এ সময় অর্ধেক ট্্িরসপি গর্তে প্রয়োগ করা দরকার। রোপণের দেড় থেকে দুই মাস পর ২৫ ভাগ ইউরিয়া, ৫০ ভাগ এমওপি এবং বাকি টিএসপি জমিতে ছিটিয়ে ভালভাবে কুপিয়ে মাটির সাথে মিশিয়ে দিতে হয়। এর দুই থেকে আড়াই মাস পর গাছপ্রতি বাকি ৫০ ভাগ ইউরিয়া ও ৫০ ভাগ এমওপি সার প্রয়োগ করা দরকার। ফুল আসার সময় অবশিষ্ট ২৫ ভাগ ইউরিয়া জমিতে ছিটিয়ে মাটির সাথে মিশিয়ে দিতে হয়।</p>
                <p>সেচ ও আগাছা ব্যবস্থাপনা: চারা রোপণের পর মাটিতে পর্যাপ্ত রস না থাকলে এবং শুকনো মৌসুমে ১৫-২০ দিন পর সেচ দিতে হবে। তাছাড়া গাছের গোড়া ও নালার আগাছা সব সময় পরিষ্কার রাখা প্রয়োজন। মোচা আসার আগ পর্যন্ত গাছের গোড়ায় কোন তেউড় রাখা উচিত নয়।</p>
                <p className="card-text"><b>রোগ ব্যবস্থাপনা: </b><br /><b>কলার পানামা রোগ দমন: </b>এটি একটি ছত্রাক জাতীয় রোগ। প্রাথমিকভাবে বয়স্ত পাতার কিনারা হলুদ হয়ে যায় এবং পরে কচি পাতাও হলুদ রঙ ধারন করে। পরপবর্তীতে পাতা বোটার কাছে ভেঙে গাছের চারিদিকে ঝুলে থাকে এবং মরে যায়।</p>
                <p className="card-text"><b>প্রতিকার: </b>আক্রান্ত গাছ গোড়াসহ উঠিয়ে ফেলা উচিত। আক্রান্ত গাছের তেউড় চারা হিসেবে ব্যবহার করা যাবে না।</p>
                <p className="card-text"><b>কলার সিগাটোকা রোগ দমন: </b>এ রোগের আক্রমনে প্রাথমিকভাবে ৩য় বা ৪র্থ পাতায় ছোট ছোট হলুদ দাগ দেখা যায়। ধীরে ধীরে দাগগুলো বড় হয়ে বাদামি রঙ ধারণ করে।</p>
                <p className="card-text"><b>প্রতিকার: </b>আক্রান্ত গাচের পাতা পুড়ে ফেলতে হয়। প্রতি লিটার পানিতে ০.৫ মি.লি টিল্ট ২৫০ ইসি অথবা ১ গ্রাম বাভিস্টিন মিশিয়ে ১৫ দিন পর পর স্প্রে করা দরকার।</p>
                <p className="card-text"><b>কলার পাতা ও ফলের বিটল পোকা: </b>কলার পাতা ও ফলে বিটল পোকা করার কচি পাতায় হাটাহাটি করে এবং সবুজ অংশ নষ্ট করে। ফলে সেখানে অসংখ্য দাগের সৃষ্টি হয়। কলা বের হওয়ার সময় হলে পোকা মোচার মধ্যে ঢুকে কচি করার ওপর হাটাহাটি করে এবং রস চুষে খায়। কলার গায়ে কসন্ত রোগের মতো দাগ হয়।</p>
                <p className="card-text"><b>প্রতিকার: </b>পোকা আক্রান্ত মাঠে বারবার কলা চাষ করা যাবে না। করার মোচা বের হওয়ার সময় ছিদ্র বিশিষ্ট পলিথিন ব্যাগ ব্যবহার করে এ পোকার আক্রমণ থেকে রক্ষা পাওয়া যায়।</p>
                <p className="card-text">আক্রমণ বেশি হলে প্রতি লিটার পানিতে ১ গ্রাম সেভিন ৮৫ ডব্লিউ পি মিশিয়ে ১৫ দিন পর পর ২ বার গাছের পাতার উপরে ছিটাতে হবে।</p>
                <p className="card-text"><b>ফসল তোলা: </b>চারা রোপণের ১১-১৫ মাসের মধ্যেই কলা সংগ্রহের উপযোগি হয়।</p>

            </div>
        </div >

    );
};

export default KolaInfo;